<template>
    <div class="filters-item filters-item--search filters-item--reset w-100">
      <v-text-field
        v-model="filters.search"
        :placeholder="$t(`${namespace}.companies.placeholder`)"
        prepend-inner-icon="search"
        :disabled="!isSuccess"
        :loading="searchIsLoading"
        color="accent"
        height="36"
        width="100"
        flat
        solo
        clearable
        hide-details
        @input="handleSearch"
      />
    </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'

export default {
  name: 'Search',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage',
      filters: {
        search: null
      }
    }
  },
  methods: {
    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.w-100 {
  display: block !important;
  width: 100% !important;
}
</style>
